<template>
  <div
    :class="[schema.fieldName, getSelectedDEV && 'dev-selected-component']"
    @contextmenu="selectComponentDEV($event, schema.model)"
  >
    <vueper-slides class="no-shadow" v-bind="schema.attributesCarousels">
      <vueper-slide
        v-for="(slide, i) in schema.items"
        :key="i"
        :image="slide.image"
        :href="slide.image"
      ></vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';

import { VueperSlides, VueperSlide } from 'vueperslides';
import 'lightgallery.js';
import 'lg-zoom.js';

export default {
  mixins: [abstractField, devComponentMixin],

  components: {
    VueperSlides,
    VueperSlide
  },

  computed: {
    paths() {
      return this.$store.getters['layout/getConfigPaths'];
    }
  },

  mounted() {
    let config = this.$store.getters['authentication/getConfig'];

    for (let i in this.schema.items) {
      if (config.DEV_MODULE) {
        this.schema.items[i].image = 'static/placeholder2.jpg';
      } else {
        this.schema.items[i].image = this.schema.items[i].image.startsWith('static')
          ? this.schema.items[i].image
          : this.paths[this.schema.items[i].image];
      }
    }

    window.lightGallery(document.querySelectorAll(`.new-${this.schema.model} .vueperslides__track-inner`)[0], {
      thumbnail: true
    });
  },

  data: () => ({
    slides: []
  })
};
</script>
